/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ChefEntrepriseSiegeSocialSearch
 */
export interface ChefEntrepriseSiegeSocialSearch {
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSiegeSocialSearch
     */
    idChefEntreprise?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChefEntrepriseSiegeSocialSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ChefEntrepriseSiegeSocialSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSiegeSocialSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSiegeSocialSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ChefEntrepriseSiegeSocialSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseSiegeSocialSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ChefEntrepriseSiegeSocialSearch interface.
 */
export function instanceOfChefEntrepriseSiegeSocialSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefEntrepriseSiegeSocialSearchFromJSON(json: any): ChefEntrepriseSiegeSocialSearch {
    return ChefEntrepriseSiegeSocialSearchFromJSONTyped(json, false);
}

export function ChefEntrepriseSiegeSocialSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefEntrepriseSiegeSocialSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idChefEntreprise': !exists(json, 'idChefEntreprise') ? undefined : json['idChefEntreprise'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ChefEntrepriseSiegeSocialSearchToJSON(value?: ChefEntrepriseSiegeSocialSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idChefEntreprise': value.idChefEntreprise,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

